module.exports = __webpack_public_path__ + "static/media/acknowledgeArr.7ba502d4.svg";